var map = {
	"./cell.svg": 44145,
	"./close.svg": 88655,
	"./dashboard.svg": 86707,
	"./drawio.svg": 88947,
	"./example.svg": 20613,
	"./exitScreen.svg": 94497,
	"./eye-open.svg": 69529,
	"./eye.svg": 26240,
	"./files.svg": 67538,
	"./folder.svg": 17273,
	"./form.svg": 44527,
	"./image.svg": 71924,
	"./link.svg": 22273,
	"./markdown.svg": 83598,
	"./nested.svg": 98236,
	"./package.svg": 90815,
	"./password.svg": 83650,
	"./screen.svg": 18081,
	"./slide.svg": 28016,
	"./table.svg": 40987,
	"./text.svg": 44664,
	"./tree.svg": 33585,
	"./user.svg": 23900,
	"./video.svg": 9678,
	"./word.svg": 72737,
	"./xmind.svg": 83923
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72922;